"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line no-unused-vars
var notificationBarStyles = {
    "invosys-ui-NotificationBar ": { zIndex: 1800 },
    "invosys-ui-NotificationBar-messageWrapper": {
        width: "30vw",
        maxWidth: "500px"
    },
    "invosys-ui-NotificationBar-actionWrapper": {
        width: "10vw",
        maxWidth: "150px",
        textAlign: "right"
    }
};
exports.default = notificationBarStyles;
